import { cn } from "cn";

function getClassNames(type: string, optionalClasses?: string): string {
	return cn("fa", `fa-${type}`, optionalClasses);
}

interface FaIconProps {
	type: string;
	title?: string;
	className?: string;
	role?: string;
	"data-testid"?: string;
}

function FaIcon(props: FaIconProps): React.ReactNode {
	const { type, role, title, className, "data-testid": dataTestId } = props;

	const classes = getClassNames(type, className);

	return (
		<i className={classes} title={title} role={role} data-testid={dataTestId} />
	);
}

export default FaIcon;
export { FaIcon, type FaIconProps, getClassNames };
